import { Component } from '@angular/core';

import { addFocus } from '../../function/add-focus.function';
import { destroyNewMyFocusHandle } from '../../function/destroy-handle.function';
import { MyFocus } from '../../state.model';

@Component({
    selector: 'cmps-ca-evaluation-new-my-focus',
    templateUrl: './new-my-focus.component.html',
})
export class NewMyFocusComponent {
    /** @private */
    _key: string;

    /** @private */
    _value: MyFocus;

    constructor() {
        this._value = {
            focus: null,
            phrase: null,
        };
    }

    /** @private */
    _onCancelClick(): void {
        destroyNewMyFocusHandle(this._key);
    }

    /** @private */
    _onSaveClick(): void {
        if (
            this._value.focus == null ||
            this._value.focus.trim().length === 0
        ) {
            return;
        }
        addFocus(this._key, this._value.focus, this._value.phrase);
        destroyNewMyFocusHandle(this._key);
    }
}
